import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Navigation from './Navigation';
import Footer from './Footer';

import classes from './index.module.css';

function Layout({ options: { showNavItems } }) {
  useEffect(() => {
    const channel = new BroadcastChannel(process.env.BROADCART_CHANNEL_NAME);
    channel.onmessage = (ev) => {
      if (ev.data === 'Authentication Complete') {
        window.location.reload();
      } else if (ev.data === 'shout') {
        channel.postMessage('echo');
      }
    };
  }, []);

  return (
    <>
      <Navigation showNavItems={showNavItems} />
      <div className={classes.page_content}>
        <Outlet />
      </div>
      <Footer showNavItems={showNavItems} />
    </>
  );
}
Layout.propTypes = {
  options: PropTypes.shape({
    showNavItems: PropTypes.bool,
  }),
};
Layout.defaultProps = {
  options: { showNavItems: true },
};

export default Layout;
